import { createSlice } from "@reduxjs/toolkit";
import {
  AllTrackingThunk,
  GetSingleTrackingThunk,
  AddTrackingThunk,
  AddTrackingHistoryThunk,
  DeleteTrackingThunk,
  DeleteTrackingHistoryThunk,
} from "./thunk";

const initialState = {
  trackings: [],
  singleTracking: null,
  loading: false,
  error: null,
  successMessage: null,
};

const trackingSlice = createSlice({
  name: "tracking",
  initialState,
  reducers: {
    clearTrackingState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- ALL TRACKINGS -------------------- */
      .addCase(AllTrackingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllTrackingThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.trackings = action.payload?.data || [];
      })
      .addCase(AllTrackingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- SINGLE TRACKING -------------------- */
      .addCase(GetSingleTrackingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleTrackingThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleTracking = action.payload?.data || null;
      })
      .addCase(GetSingleTrackingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD/UPDATE TRACKING -------------------- */
      .addCase(AddTrackingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddTrackingThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Tracking added/updated successfully!";
      })
      .addCase(AddTrackingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE TRACKING -------------------- */
      .addCase(DeleteTrackingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DeleteTrackingThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.trackings = state.trackings.filter(
          (t) => t.tracking_number !== action.payload.tracking_number
        );
        state.successMessage = action.payload.message;
      })
      .addCase(DeleteTrackingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD TRACKING HISTORY -------------------- */
      .addCase(AddTrackingHistoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddTrackingHistoryThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Tracking history added successfully!";
      })
      .addCase(AddTrackingHistoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE TRACKING HISTORY -------------------- */
      .addCase(DeleteTrackingHistoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DeleteTrackingHistoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(DeleteTrackingHistoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTrackingState } = trackingSlice.actions;
export default trackingSlice.reducer;
